import React from 'react'
import Hero from '../components/Hero'
import Case from '../modules/UseCases/Case'
import styled from 'styled-components'
import Dots from '../components/Dots'
import Action from '../components/Action'
import Helmet from 'react-helmet'

import facebook from '../modules/UseCases/facebook.png'
import presentation from '../modules/UseCases/presentation.png'
import appstore from '../modules/UseCases/appstore.png'
import support from '../modules/UseCases/support.png'
import announcement from '../modules/UseCases/announcement.png'
import documentation from '../modules/UseCases/documentation.png'

const UseCases = () => (
  <div>
    <Helmet>
      <title>Use cases - shotsnapp</title>
      <meta
        name="description"
        content="Use shotsnapp to generate beautiful images for social media post, app store screenshot, product announcement and more."
      />
    </Helmet>
    <Wrapper>
      <Hero
        title="What can you use it for?"
        subtitle="You should be able to use shotsnapp for anything you could imagine from social media post, product announcements, app store screenshots, marketing image and many more. Here are some common use cases."
      />

      <div className="container">
        <Grid>
          <Row>
            <Dots
              color="rgba(255,255,255,0.1)"
              width={300}
              height={200}
              style={{
                position: 'absolute',
                bottom: -80,
                right: -60,
              }}
            />
            <Col>
              <Case
                title="Social media posts"
                desc="You can use shotsnapp to design and create beautiful images that will excite your audience across
        your social media platforms like Facebook, Twitter and Instagram. Include screenshots of your apps with good looking devices."
                image={facebook}
              />
            </Col>
            <Col>
              <Case
                title="Feature announcements"
                desc="Product announcement is usually accompanied by the visual of your product. Never be buried among other noises anymore. Create good looking images and announce your new features or product in style."
                image={announcement}
              />
            </Col>
          </Row>
          <Row>
            <Dots
              color="rgba(255,255,255,0.1)"
              width={100}
              height={300}
              style={{
                position: 'absolute',
                bottom: 80,
                left: -60,
              }}
            />
            <Col>
              <Case
                title="Presentations"
                desc="Plain screenshots are so boring. Spice up your presentation slides with pratical yet eye-catching representation of your work to give better context to your audience."
                image={presentation}
              />
            </Col>
            <Col>
              <Case
                title="App store screenshots"
                desc="You only have limited chance to grab attention of your viewer. With shotsnapp, designing and generating screenshots for your app store listing will no longer take hours."
                image={appstore}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Case
                title="Support & helpdesk"
                desc="Provice enough context for your users in your support flow. Visually guide them with useful and beautiful screenshots of your product."
                image={support}
              />
            </Col>
            <Col>
              <Case
                title="Documentations"
                desc="Include your wireframes and design revisions with beautiful mockups in your documents. "
                image={documentation}
              />
            </Col>
          </Row>
        </Grid>
      </div>
      <Action />
    </Wrapper>
  </div>
)

export default UseCases

const Wrapper = styled.div`
  background: #4e00d9;
  padding-bottom: 40px;
  background-image: linear-gradient(-133deg, #531a9b 0%, #3023ae 100%);
`
const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
`
const Row = styled.div`
  display: flex;
  margin: 0 -20px;
  position: relative;
  align-items: flex-start;
  justify-content: space-between;
  @media (max-width: 600px) {
    flex-direction: column;
    margin: 0;
  }
`
const Col = styled.div`
  width: calc(50% - 40px);
  margin: 0 20px 40px;
  display: flex;
  overflow: hidden;
  border-radius: 6px;
  flex-direction: column;
  background-color: #fff;
  justify-content: space-between;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  transition: all ease-out 0.15s;
  padding: 25px;

  @media (max-width: 600px) {
    margin: 0 0 20px;
    width: 100%;
    padding: 15px;
  }
  &:hover {
    transform: scale(1.01);
  }
  .text {
    text-align: left;
    padding: 10px 20px 30px;
    @media (max-width: 768px) {
      padding: 10px 20px 20px;
      text-align: center;
    }
  }
  h2 {
    font-size: 28px;
    flex: 2;
    color: #000;
    margin: 0 0 10px;
    line-height: 1.2;
    @media (max-width: 600px) {
      font-size: 24px;
    }
  }
  p {
    margin-bottom: 0;
    line-height: 1.4;
  }
  img {
    display: block;
    margin: 0;
    border-radius: 4px;
  }
`



// WEBPACK FOOTER //
// ./src/pages/use-cases.js